import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation(); // This gets the current pathname

  useEffect(() => {
    // This will scroll to the top whenever the pathname changes
    window.scrollTo(0, 0);
  }, [pathname]); // Re-run the effect when the pathname changes

  return null; // This component doesn't render anything visible
}

export default ScrollToTop;
